import styled from 'styled-components';

type IndividualStepProps = {
  currentIndex: number;
  title: string;
  completedStepIndexes: Set<number>;
  ownIndex: number;
  mobileTitle: string | undefined;
};
export const IndividualStep = ({
  currentIndex,
  ownIndex,
  title,
  completedStepIndexes,
  mobileTitle,
}: IndividualStepProps) => {
  const isCompleted = completedStepIndexes.has(ownIndex);
  const isCurrentIndex = ownIndex === currentIndex;

  return (
    <StyledIndividualStep>
      {ownIndex > 0 && (
        <StyledSeparator isCompleted={isCompleted}>
          <div className='line-separator' />
        </StyledSeparator>
      )}
      <StyledIndex isCompleted={isCompleted}>
        <div className='step-content'>{ownIndex + 1}</div>
      </StyledIndex>
      <StyledTitle isCurrentIndex={isCurrentIndex} isCompleted={isCompleted}>
        {title}
      </StyledTitle>
      <StyledMobileTitle
        isCurrentIndex={isCurrentIndex}
        isCompleted={isCompleted}
      >
        {mobileTitle ?? title}
      </StyledMobileTitle>
    </StyledIndividualStep>
  );
};

const StyledIndividualStep = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  position: relative;
  font-size: 14px;
  line-height: 20px;

  @media (max-width: 960px) {
    flex-direction: column;
    flex: 1;
    align-items: normal;
  }
`;

type StyledIndexProps = {
  isCompleted: boolean;
};
const StyledIndex = styled.div<StyledIndexProps>`
  width: 32px;
  height: 32px;
  display: flex;

  justify-content: center;
  align-items: center;

  div.step-content {
    width: 28px;
    height: 28px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: ${({ theme, isCompleted }) =>
      isCompleted ? '#fff' : theme.palette.text[9]};
    background-color: ${({ theme, isCompleted }) =>
      isCompleted ? theme.palette.primary[0] : 'transparent'};

    /* border */
    border-width: 1px;
    border-style: solid;
    border-radius: 50%;
    border-color: ${({ theme, isCompleted }) =>
      isCompleted ? 'transparent' : theme.palette.text[9]};
  }

  @media (max-width: 960px) {
    align-self: center;
  }
`;

type StyledTitleProps = {
  isCurrentIndex: boolean;
  isCompleted: boolean;
};
const StyledTitle = styled.p<StyledTitleProps>`
  flex-grow: 1;
  margin: 0;
  font-weight: ${({ isCompleted }) => (isCompleted ? 600 : 400)};
  color: ${({ theme, isCurrentIndex, isCompleted }) => {
    if (isCurrentIndex) {
      return theme.palette.primary[0];
    }
    if (isCompleted) {
      return theme.palette.text[0];
    }
    return theme.palette.text[9];
  }};

  @media (max-width: 960px) {
    display: none;
  }
`;

const StyledMobileTitle = styled(StyledTitle)`
  display: none;

  @media (max-width: 960px) {
    display: block;
    text-align: center;
  }
`;

const StyledSeparator = styled.div<StyledIndexProps>`
  position: absolute;
  top: -32px;
  height: 32px;
  width: 32px;
  display: flex;
  justify-content: center;
  align-items: center;

  div.line-separator {
    width: 1px;
    height: 24px;
    background-color: ${({ theme, isCompleted }) =>
      isCompleted ? theme.palette.primary[0] : theme.palette.text[9]};
  }

  @media (max-width: 960px) {
    width: calc(100% - 32px);
    top: 6px;
    left: calc(16px - 50%);
    height: 20px;
    div.line-separator {
      width: calc(100% - 8px);
      height: 1px;
    }
  }
`;
